import { render, staticRenderFns } from "./TableInspectionGroup.vue?vue&type=template&id=349add4d&scoped=true"
import script from "./TableInspectionGroup.vue?vue&type=script&lang=js"
export * from "./TableInspectionGroup.vue?vue&type=script&lang=js"
import style0 from "./TableInspectionGroup.vue?vue&type=style&index=0&id=349add4d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349add4d",
  null
  
)

export default component.exports